<template>
  <div class="homeCenter clearfix">
    <div class="titleBox">
      <h1 class="mb-2">{{wenhouStr}}</h1>
      <p>雪帝数字音频·经销商端口，我们提供“一站式”音频解决方案！</p>
    </div>
    <div v-if="loading" class="loadingBox">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="bannerBox mb-4">
      <swiper class='aa' ref="mySwiper" :options="swiperOption">
        <swiper-slide class="swiper-slide" v-for="(item,index) in headImgs" :key="index">
          <a v-if="item.url" target="_blank" :href="item.url"><img :src="ossImgDomain+item.path"/></a>
          <img v-else :src="ossImgDomain+item.path"/>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div class="swiper-button-prev huanchongKuai" @click='prev'></div>
      <div class="swiper-button-next huanchongKuai" @click='next'></div>
    </div>
    <div class="tongjiBox mb-4">
      <div class="lis">
        <h3>账期待付</h3>
        <hr>
        <span>共{{tongjiData.daifukuanNum}}单</span>
        <div class="price">
          ￥{{tongjiData.daifukuan}} <small v-if="tongjiData.daifukuanMeijin" style="font-size: 12px;">+${{tongjiData.daifukuanMeijin}}</small>
        </div>
      </div>
      <div class="lis">
        <h3>账期待退</h3>
        <hr>
        <span>共{{tongjiData.daiTuikuanNum}}单</span>
        <div class="price">
          ￥{{tongjiData.daiTuikuan}} <small v-if="tongjiData.daiTuikuanMeijin" style="font-size: 12px;">+${{tongjiData.daiTuikuanMeijin}}</small>
        </div>
      </div>
      <div class="lis">
        <h3>等待发货</h3>
        <hr>
        <span>共{{tongjiData.daifaNum}}单</span>
        <div class="price">
          {{tongjiData.daifa}} 个
        </div>
      </div>
      <div class="lis">
        <h3>开票申请待处理</h3>
        <hr>
        <span>共{{tongjiData.daishenNum}}单</span>
        <div class="price">
          ￥{{tongjiData.daishen}}
        </div>
      </div>
    </div>
    <div class="tongjiBox mb-4">
      <div class="lis">
        <h3>授权品牌</h3>
        <hr>
        <div class="price">
          {{tongjiData.pinpaiNum}} 个 </div>
      </div>
      <div class="lis">
        <h3>代理商品</h3>
        <hr>
        <div class="price">
          {{tongjiData.goodsNum}} 个
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Swiper,SwiperSlide,directive} from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';
import Swipers, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper'
import generalMix from '@/util/mix/general';
import commons from '@/util/commons';
import resultCommons from '@/util/resultcommons';
Swipers.use([Navigation, Pagination, EffectFade, Autoplay])

export default {
  name: 'homeCenter',
  mixins: [generalMix],
  data () {
    return {
      loading:true,
      // 统计
      tongjiData:{},
      // 头图
      ossImgDomain: process.env.OSS_IMG_DOMAIN,
      headImgs:[{url:'',path:'xuedi/2504/7360774846614471.jpg'}],
      wenhouStr:'',
      swiperOption:{
        slidesPerView: 'auto',
        speed:600,
        centeredSlides:true,
        spaceBetween: 0,
        loop:true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction:false
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable:true,
          clickableClass:'active'
        }
      }
    }
  },
  methods:{
    prev(){
      this.$refs.mySwiper.$swiper.slidePrev()
    },
    next(){
      this.$refs.mySwiper.$swiper.slideNext()
    }
  },
  created() {
    // 加载中
    this.loading = true;
    resultCommons.apiHomeindex(this,{}).then(app=>{
      if(app.state === 200){
        this.headImgs = app.data.loopArr;
        resultCommons.apiHometongji(this,{}).then(app=>{
          if(app.state === 200){
            this.tongjiData = app.data;
            this.loading = false;
          }else{
            this.$message.showMsgBox({
              type: 'warning',
              content: '请求失败'
            });
          }
        });
      }else{
        this.$message.showMsgBox({
          type: 'warning',
          content: '请求失败'
        });
      }
    });

    // 条件
    this.wenhouStr = commons.wenhouStr();
  },
  components: {
    Swiper:Swiper,
    SwiperSlide:SwiperSlide
  },
  directives: {
    swiper: directive
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>
	.homeCenter {
    div.loadingBox{
      margin-bottom: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      background: url("/static/images/staticsimg.jpg") no-repeat center center;
      background-size: cover;
      background: #36353D;
      min-height: 90vh;
      .spinner-border{
        width: 3rem;
        height: 3rem;
      }
    }
    .titleBox {
      margin-top: 30px;
      color: #FFFFFF;
      margin-bottom: 30px;
      p {
        margin: 0;
        color: rgba(255, 255, 255, 0.5);
      }
      h2{
        span{
          float: right;
        }
      }
    }
    div.bannerBox{
      position: relative;
      border-radius: 5px;
      overflow: hidden;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
      z-index: 0;
      img{
        width: 100%;
      }
      .swiper-button-prev{
        background: #FFFFFF;
        background: rgba(255,255,255,0.3);
        width: 45px;
        height: 45px;
        border-radius: 50%;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
        &::after{
          font-size: 20px;
          font-weight: bold;
          color: #FFFFFF;
        }
        &:hover{
          background: rgba(255,255,255,1);
          &::after{
            color: #000000;
          }
        }
      }
      .swiper-button-next{
        background: #FFFFFF;
        background: rgba(255,255,255,0.3);
        width: 45px;
        height: 45px;
        border-radius: 50%;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
        &::after{
          font-size: 20px;
          font-weight: bold;
          color: #FFFFFF;
        }
        &:hover{
          background: rgba(255,255,255,1);
          &::after{
            color: #000000;
          }
        }
      }
    }
    div.tongjiBox{
      display: flex;
      div.lis{
        flex: 1;
        margin-right: 20px;
        background: #36353D;
        background: rgba(42,55,254,1);
        border-radius: 5px;
        padding:40px 20px;
        text-align: center;
        /*box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);*/
        h3{
          font-size: 16px;
          margin-bottom: 15px;
        }
        hr{
          border-color: rgba(0,0,0,0.2);
          margin-top: 20px;
          margin-bottom: 20px;
        }
        div.price{
          font-size: 26px;
          letter-spacing: 0;
          font-weight: bold;
          border-radius: 5px;
          margin-top: 15px;
        }
        span{
          color: rgba(255,255,255,0.6);
        }
        &:last-child{
          margin: 0;
        }
        &.kefu{
          display: none;
        }
      }
    }
  }
  @media (max-width: 1200px) {
    .homeCenter{
    }
  }
  @media (max-width: 992px) {
    .homeCenter{
      .titleBox {
        margin-top: 30px;
        margin-bottom: 30px;
        p {
          margin: 0;
          color: #9B9B9B;
        }
      }
    }
  }
  @media (max-width: 767px) {
    .homeCenter{
      .titleBox {
        margin-top: 50px;
        text-align: center;
        p{
          padding: 0 15px;
        }
      }
      div.tongjiBox{
        display: block;
        div.lis{
          padding:30px 20px;
          margin: 0;
          margin-bottom: 20px;
          h3{
            color: rgba(255,255,255,0.3);
            font-size: 14px;
          }
          hr{
            margin: 15px 0;
          }
          div.price{
            margin-top: 10px;
            font-size: 22px;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/home/Center.vue